import { Box } from '@mui/material';
import { Layout } from 'react-admin';
import { ReactQueryDevtools } from 'react-query/devtools';
import RouteGuard from '../components/RouteGuard';
import { CustomAppBar } from './CustomAppBar';
import { Menu } from './Menu';

export const CustomLayout = props => {
  const numVersion = process.env.REACT_APP_VERSION || '1.0.1';
  return (
    <>
      <RouteGuard>
        <Layout {...props} menu={Menu} appBar={CustomAppBar} />
      </RouteGuard>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
      <Box
        sx={{
          position: 'absolute',
          zIndex: '1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          right: '0',
          padding: '6px',
          paddingRight: '8px',
          fontSize: '11px',
          background: '#f3f3f3',
          width: '100%',
        }}
      >
        {`${new Date().getFullYear()}™ - Todos los derechos reservados - Versión ${numVersion}`}
      </Box>
    </>
  );
};
